import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CTASection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section ref={ref} className="overflow-hidden">
      <div className={`scroll-hidden-scale-blur ${isVisible ? 'scroll-visible' : ''} w-full bg-gradient-to-br from-[#1E3A8A] to-[#2D1B69] relative flex items-center justify-center px-14 py-24`}>
        {/* Slow-float decorative orb */}
        <div className="absolute top-10 right-16 w-28 h-28 rounded-full bg-brand-yellow/15 blur-2xl pointer-events-none float-slow" />
        <div className="absolute bottom-10 left-16 w-20 h-20 rounded-full bg-brand-purple-light/20 blur-2xl pointer-events-none float-slow-delay" />

        <div className="relative z-10 w-full max-w-md text-center">
          <span className={`scroll-hidden-pop ${isVisible ? 'scroll-visible' : ''} delay-200 inline-block px-4 py-1.5 rounded-full border border-brand-yellow/40 text-brand-yellow font-body text-xs uppercase tracking-widest bg-brand-yellow/10 mb-4`}>
            Enrollment Open
          </span>
          <h2 className={`scroll-hidden ${isVisible ? 'scroll-visible' : ''} delay-300 font-heading text-5xl font-black text-white mb-4`}>Enroll Today</h2>
          <p className={`scroll-hidden-blur ${isVisible ? 'scroll-visible' : ''} delay-400 font-body text-white/60 text-base mb-8 leading-relaxed`}>
            Where your creativity is refined, developed, and elevated with intention.
          </p>

          <Link
            to="/enroll"
            className={`scroll-hidden ${isVisible ? 'scroll-visible' : ''} delay-500 btn-shimmer whitespace-nowrap block w-full py-5 rounded-full bg-brand-yellow text-brand-blue-dark font-body font-bold text-lg hover:bg-brand-yellow-light transition-all duration-300 cursor-pointer mb-8`}
          >
            Enroll Now
          </Link>

          <div className={`scroll-hidden-blur ${isVisible ? 'scroll-visible' : ''} delay-600 flex flex-col gap-3`}>
            <a
              href="mailto:info@creativeinstitutellc.com"
              className="flex items-center justify-center gap-3 font-body text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-brand-purple text-base" />
              </div>
              info@creativeinstitutellc.com
            </a>
            <a
              href="tel:9102424567"
              className="flex items-center justify-center gap-3 font-body text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-brand-purple text-base" />
              </div>
              910-242-4567
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
